<template>

    <div style="margin:15px;" class='order-container shadow-1'>
        <div class="order-title shadow-1 row justify-start q-title">
            <div>Заказ № {{ order.main_id }}</div>
            <div class='q-ml-lg q-mr-lg'>|</div>
            <div>{{getCreatedDate}}</div>
        </div>
        
        <div class='full-width q-mt-md' style='text-align:center;'><img :src="options.preview_1" class="preview lt-md"></div>

        <div class="order-container row justify-center gt-xs">
            <div class="left-container" >
                <p>Менеджер заказа: {{managerName}}</p>
                <p><strong>Заказчик: {{contragentName}}</strong></p>
                <div class='row q-mb-sm items-baseline'>
                    <div>Готовность:</div> 
                    <div class='text-red q-ml-xs text-weight-bold q-headline'>
                        {{wishDate}} 
                    </div>
                </div>
                <div class="print-param-container">
                    <div class="print-param-title">
                        Параметры печати
                    </div>
                    <div>
                        <div class='row no-wrap justify-between'>
                            <div class='q-xs-12 q-sm-12 q-md-6 q-lg-6 q-xl-6 ellipsis-2-lines'>
                                <div class="row no-wrap ellipsis">
                                    <div class="print-param">Станок:</div><div class="print-param-value ellipsis" style="color:#0195c5">{{stanokName}}</div>
                                </div>    

                                <div class="row no-wrap">
                                    <div class="print-param">Размер:</div><div class="print-param-value">{{options.width}} x {{options.height}} м</div>
                                </div>    
                                <div class="row no-wrap">
                                    <div class="print-param">Материал:</div><div class="print-param-value" style="color:#0195c5">{{materialName}}</div>
                                </div>
                                <div class="row no-wrap">
                                    <div class="print-param">Качество:</div><div class="print-param-value" style='color:green'>{{qualityName}}</div>
                                </div>
                            </div>
                            <div class='row justify-between text-center'>
                                <div style="text-align:center;  margin-top:12px;" class='gt-md q-mr-md'>
                                    <div class="count-title bg-yellow">
                                        количество, шт
                                    </div>
                                    <div class="count-container">
                                        {{number}}
                                    </div>

                                </div>
                            </div>
                        </div>
                        <!-- если маленькое разрешение -->
                        <div class='row justify-center lt-lg'>
                            <div style="text-align:center; width:50%; margin-top:10px;">
                                <div class="count-title bg-yellow">
                                    количество, шт
                                </div>
                                <div class="count-container">
                                    {{number}}
                                </div>
                            </div>
                        </div>
                        <!-- конец -->                        
                    </div>
                </div>
                 <div class="print-param-container" style="margin-top:10px">
                    <div class="print-param-title post-param-title">
                        Параметры обработки
                    </div>

                    <print-terminal-show-post :order='order'/>
                 </div>
                 <div class="print-param-container q-pa-xs" style="margin-top:10px">
                    <div class='row q-caption q-ma-xs items-baseline'>
                        <div class='q-mr-xs q-body-1 text-weight-bold text-faded'>Комментарии к заказу: </div> {{order.comment}}
                    </div>
                    <div class='row q-caption q-ma-xs q-mt-md items-baseline'>
                        <div class='q-mr-xs q-body-1 text-weight-bold text-faded'>Комментарии к файлу: </div> {{getFileComment}}
                    </div>
                    <div class='row q-title q-ma-xs q-mt-md items-baseline text-red text-weight-bold'>
                        <div class='q-mr-xs q-title '>Подписать: </div> {{getFileTitle}}
                    </div>

                 </div>


            </div>
            <div class="right-container">
                
                <div class="row no-wrap justify-center items-end">

                    <img :src="options.preview_1" class="preview gt-sm">
                    
                    <!-- Списание заказа -->
                    
                    <q-btn round icon="add" color="primary" class="to-write-off gt-md"> 

                        <q-popover ref="popover" touch-position class= "file-write-off-count-container" @show="correctCount">
                        
                                <div>
                                    <q-slider
                                        v-model="writeOffFileCount"
                                        :min="0"
                                        :max="maxWriteOffCount"
                                        :step="1"
                                        label
                                        markers
                                        snap
                                        label-always
                                    />
                                </div>
                                <div>
                                    <q-input 
                                        v-model="writeOffFileCount" 
                                        suffix='шт'
                                        type="number"
                                        align='center'
                                    />
                                </div>
                                <q-btn 
                                    color='positive'  
                                    icon='vertical_align_bottom'
                                    label="В СБОРКУ"
                                    @click="addToWriteOff"
                                    style="margin-top:20px;"/>
                        </q-popover>
                    </q-btn>
                </div>
                <print-terminal-file-dialog
                    :file_id="order.id"
                />
                <write-off-legend
                    :orderId='order.id'
                    :number="number"
                    class='q-mt-md'
                />
            </div>
        </div>

<!-- Маленькое разрешение ------------------------------------------------- -->

        <div class=" row justify-center lt-sm">
            <div class="" >
                <div class='q-ma-sm q-body-2'>
                    <p>Менеджер заказа: {{managerName}}</p>
                    <p>Готовность: {{wishDate}}</p>
                </div>
                <div class="print-param-container">
                    <div class="print-param-title">
                        Параметры печати
                    </div>
                    <div>
                        <div class='row no-wrap justify-between'>
                            <div class='q-xs-12 q-sm-12 q-md-6 q-lg-6 q-xl-6 ellipsis-2-lines'>
                                <div class="row no-wrap ellipsis">
                                    <div class="print-param">Станок:</div><div class="print-param-value ellipsis" style="color:#0195c5">{{stanokName}}</div>
                                </div>    

                                <div class="row no-wrap">
                                    <div class="print-param">Размер:</div><div class="print-param-value">{{options.width}} x {{options.height}} м</div>
                                </div>    
                                <div class="row no-wrap">
                                    <div class="print-param">Материал:</div><div class="print-param-value" style="color:#0195c5">{{materialName}}</div>
                                </div>
                                <div class="row no-wrap">
                                    <div class="print-param">Качество:</div><div class="print-param-value" style='color:green'>{{qualityName}}</div>
                                </div>
                            </div>
                            <div class='row justify-between text-center'>
                                <div style="text-align:center;  margin-top:12px;" class='gt-md q-mr-md'>
                                    <div class="count-title bg-yellow">
                                        количество, шт
                                    </div>
                                    <div class="count-container">
                                        {{number}}
                                    </div>

                                </div>
                            </div>
                        </div>
                        <!-- если маленькое разрешение -->
                        <div class='row justify-center lt-lg'>
                            <div style="text-align:center; width:50%; margin-top:10px;">
                                <div class="count-title bg-yellow">
                                    количество, шт
                                </div>
                                <div class="count-container">
                                    {{number}}
                                </div>
                            </div>
                        </div>
                        <!-- конец -->                        
                    </div>
                </div>
                 <div class="print-param-container" style="margin-top:10px">
                    <div class="print-param-title post-param-title">
                        Параметры обработки
                    </div>

                    <print-terminal-show-post :order='order'/>

                 </div>

            </div>
                
                <print-terminal-file-dialog
                    :file_id="order.id"
                />
                <write-off-legend
                    :orderId='order.id'
                    :number="number"
                    class='q-mt-md'
                />
        </div>
    </div>

</template>

<script>
/* eslint-disable */
import printTerminalShowPost from './printTerminalShowPost';
import printTerminalFileDialog from './printTerminalFileDialog';

const month = [
        'января', "февраля", "марта", "апреля", "мая", "июня", "июля", "августа", "сентября", "октября", "ноября", "декабря"
    ];

export default {
    
    name : 'printOrder',

    props : {
        order : {
            type: Object,
            requered: true,
        },
    },

     data () {
            return {
                showWriteOffContainer : false,
                writeOffFileCount : 1,
                options : null,
                maxWriteOffCount : 1,
            }
    },

    components : {
        printTerminalShowPost,
        printTerminalFileDialog,
        writeOffLegend : () => import('./printTerminalWriteOffLegend.vue'),
    },

    created() {
        this.options = JSON.parse(this.order.options);
        this.writeOffFileCount = this.order.number;
        this.maxWriteOffCount = this.order.number;
    },
    
    methods : {
        
        correctCount() {
            let readyCount = this.$store.getters.getReadyCount(this.order.id);
            this.writeOffFileCount = (this.options.number - readyCount);
            if (this.writeOffFileCount<0) this.writeOffFileCount = 0;
            this.maxWriteOffCount = this.writeOffFileCount;

        },

        addToWriteOff() {
            this.$refs.popover.hide();
            if (this.$store.getters.isFileInWriteOff(this.order.id)) {
                 this.$admns.showNotify('Такой файл уже есть в сборке','error','Сообщение системы');
            }
            else {
                this.$store.commit('addFileToWriteOff', {count:this.writeOffFileCount, order:this.order})
                this.$admns.showNotify('Файл успешно добавлен в сборку','success','Сообщение системы');
            }
        },
    },
    computed : {
        getFileTitle() {
            return (this.options.title != null) ? this.options.title : '';
        },
        getFileComment() {
            return (this.options.comment != undefined) ? this.options.comment : '';
        },
        getCreatedDate() {
            let q = new Date(this.order.created_at);
            return q.toLocaleDateString();
        },

        number() {
            return (this.options.number != undefined) ? this.options.number : 0;
        },
        stanokName() {
            if (this.$store.getters.getDirectionById(this.options.stanok) != undefined) return this.$store.getters.getDirectionById(this.options.stanok).name;
            return "Не задан";
        },
        materialName() {
            // let opt = JSON.parse(this.order.options);
            if (this.$store.getters.getMaterialById(this.options.material) != undefined) return this.$store.getters.getMaterialById(this.options.material).name;
            return "Не задан";
        },
        qualityName() {
            if (this.$store.getters.getQualityById(this.options.quality) != undefined) return this.$store.getters.getQualityById(this.options.quality).name;
            return "Не задан";
        },

        contragentName() {
            let q = this.$store.getters.getContragentById(this.order.contragent);
            return q != null ? (q.name) : 'Не задан';
        },

        managerName() {
            let q = this.$store.getters.getUserById(this.order.manager);
            return q != null ? (q.name +" " + q.surname) : 'Не задан';
        },

        wishDate() {
                if (this.order.wish_date == null) return '';
                let d = new Date(this.order.wish_date);                
                return d.toLocaleString();
        }

    },
}
</script>

<style lang="scss" scoped>
    .file-write-off-count-container {
        width:250px;
        min-height:150px;
        border : 2px solid #027be3;
        border-radius: 10px;
        padding: 30px;
        padding-top:5px;
        padding-bottom: 15px;
        text-align:center;
    }
    .to-write-off {
        position: relative;
        bottom:-10px;
        left : -15px;
    }

    .order-title {
        background: rgb(99, 0, 0);
        color : white;
        // font-size : 18px;
        padding : 8px;
        // font-family: Arial, Helvetica, sans-serif;
    }
    .order-container {
        background: rgb(238, 238, 238);
        min-height : 100px;
        margin-bottom: 15px;      
    }
    .left-container {
        width:50%;
        min-width: 250px;
        padding : 15px;   
    }
    .right-container {
        width : 50%;
        // padding : 10px;
        
        text-align : center;
    }
    .print-param-container {
        border : 1px solid rgb(214, 214, 214);
        min-height: 100px;
        background: #e6e6e6;

        .print-param-title {
            padding : 8px;
            background:  #065baf;
            color : white;
            font-size: 15px;
            margin-bottom: 10px;
        }
        .print-param {
            float: left;
            font-size:12px;
            font-weight: bold;
            line-height: 27px;
            min-width:75px;
            padding:5px;
            padding-left:10px;
            text-transform  : lowercase;
        }
        .print-param-value {
            font-size:20px;
            // font-family:  Arial, Helvetica, sans-serif;
            font-weight: bold;
            padding:5px;
            color:red;
        }
        .count-title {
            font-size:18px;
            // font-family: Arial, Helvetica, sans-serif;
            background: rgb(107, 29, 29);
            text-transform: lowercase;
            color : rgb(236, 2, 2);
            width:150px;
            margin:auto;
        }
        .count-container {
            font-size:35px;
            // font-family: Arial, Helvetica, sans-serif;
            text-transform: lowercase;
            font-weight: bold;
            min-height:50px;
            line-height: 55px;
            background: white;
            color : rgb(236, 2, 2);
            width:150px;
            border:1px solid rgb(211, 211, 211);
            border-top:none;
            margin:auto;
        }
        .post-param-title {
            background: #0982ff;
        }
    }
    .preview {
        background: white;
        border : 1px solid rgb(214, 214, 214);
        padding : 5px;
        max-width: 100%;
        max-height: 100%;
        width: auto;
        height: auto;

    }

</style>
